import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class DemographicService {

  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }


  public getDemographics(){

    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.demograficos.getDemographics+this.getCompanyID());
    // return this.httpClient.get(this.ip+'/api_empresa/Demograficos/'+this.getCompanyID(),
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getLanguajesListNon3(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListNon3+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Idiomas/all/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getLanguajesListSelected() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListSelected+this.getCompanyID());
    // return this.httpClient.get(this.ip+'/api_empresa/Idiomas/agregados/'+this.getCompanyID(),
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getQuestions(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getTiposDemograficos+this.getCompanyID(),data);
  }
  //   return this.httpClient.post(this.ip+'/api_empresa/Demograficos/all/'+this.getCompanyID(),data,
  // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  // }

  public insertTraduccion(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.insertTraduccion+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/traducciones/'+this.getCompanyID(),data,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public addResponse(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.addResponse+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Guardar/Opcion/'+this.getCompanyID(),data,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public setBanderaDemograficos(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.setBanderaDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Guardar/Bandera/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveNewDemografico(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.saveNewDemografico+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Agregar/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public guardarDemograficos(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.guardarDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Guardar/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public catalogoDemograficos(data){
    //console.log(data);
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.catalogoDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Catalogo/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public deleteDemografico(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.deleteDemografico+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Eliminar/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getBanderaDemograficos(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.getBanderaDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Bandera/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getPreview(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getDemograficosGuardadosTmp+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/traduccion/get/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public obtenerDemograficos(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.obtenerDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/traducciones/get/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public getTranslate(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.insertTraduccion+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/traducciones/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveQuestionTranslate(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.saveQuestionTranslate+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Guardar/Traduccion/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveOpcionTranslate(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.saveOpcionTranslate+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demogradicos/Guardar/Opcion/Traduccion/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public updateDemographicData(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.updateDemographicData+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/update/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public addquestion(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.addquestion+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/addDemografico/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public setCierre(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.setCierre+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/terminar/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
//repetido guardarDemograficos
  public saveDemographic(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.guardarDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Guardar/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveDemographicOption(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.demograficos.addResponse+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Demograficos/Guardar/Opcion/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }


  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }


}
